import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { RECENT_EVENTS } from '../../Assets/data/common';
import PublicHeader from '../Header/PublicHeader';
import Footer from '../Footer';
import { ArrowRight } from 'react-bootstrap-icons'

const HeroSection = () => (
  <header className=' text-center  text-white' style={{ background: "linear-gradient(180deg, #0078BF 0%, #244183 100%" }}>
    <div className='section-header'>
      <motion.h1
        className='text-4xl md:text-6xl display-4 fw-bold text-center text-white'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Past Events
      </motion.h1>
      
    </div>
  </header>
);

const PastEvents = () => {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false)

  return (
    <>
      <PublicHeader />
      <HeroSection />
      <section className='bg-[#F5F5F5] py-8 md:py-12'>
        <div className='px-4'>
          {/* <div className='text-center mb-8 md:mb-16'>
            <h2 className='text-3xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4'>Past Events</h2>
            <p className='text-gray-600 text-base md:text-lg max-w-2xl mx-auto'>
              Discover our latest gatherings and stay connected with the community
            </p>
          </div> */}

          <div className='grid gap-6 md:gap-8 max-w-8xl md:mx-0 container mx-auto'>
            {RECENT_EVENTS.slice(0, window.innerWidth <= 768 ? (showAll ? 8 : 4) : 8).map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{
                  scale: window.innerWidth > 768 ? 1.03 : 1,
                  transition: { duration: 0.2 }
                }}
                className='bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row'
              >
                <div className={`w-full ${index % 2 !== 0 ? 'md:order-2' : ''} md:w-2/4 h-[200px] relative`}>
                  <img
                    src={event.image}
                    alt={event.title}
                    className={`w-full ${window.innerWidth <= 768 ? "h-[200px]" : "h-[250px]"} object-cover p-3`}
                    style={{ borderRadius: "30px" }}
                  />
                </div>
                <div className={`w-full ${index % 2 !== 0 ? 'md:order-1' : ''} p-4 md:p-6`}>
                  <h3 className='text-xl font-bold text-gray-800 mb-2'>
                    {event.title}
                  </h3>
                  <div className='flex flex-wrap items-center text-gray-500 text-sm mb-4'>
                    <div className='flex items-center mr-4 mb-2 md:mb-0'>
                      <svg className='w-4 h-4 mr-1.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' />
                      </svg>
                      {event.date}
                    </div>
                    <div className='flex items-center'>
                      <svg className='w-4 h-4 mr-1.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' />
                      </svg>
                      {event.attendees} attendees
                    </div>
                  </div>
                  <p className='text-gray-600 text-sm md:text-base leading-relaxed mb-4'>
                    {event.description.length > 500
                      ? `${event.description.slice(0, 300)}...`
                      : event.description}
                  </p>
                  <div className='flex justify-start md:justify-end'>
                    <button
                      className='text-[#0d73b9] text-sm font-medium hover:text-blue-700 transition-colors flex items-center'
                      onClick={() => navigate(`/event/${event.id}`)}
                    >
                      Learn More
                      <ArrowRight className='ml-2' />
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          {window.innerWidth <= 768 && RECENT_EVENTS.length > 4 && (
            <div className='mt-6 md:mt-8 text-center'>
              <button
                onClick={() => setShowAll(!showAll)}
                className='bg-white text-[#0d73b9] px-6 py-2 rounded-full font-medium hover:bg-opacity-90 transition-all flex items-center mx-auto'
              >
                {showAll ? 'See Less' : 'See More'}
                <ArrowRight className={`ml-2 transition-transform ${showAll ? 'rotate-180' : ''}`} />
              </button>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PastEvents;